import { render } from "./product-card-simple.vue?vue&type=template&id=08d1cf3e"
import script from "./product-card-simple.vue?vue&type=script&lang=js"
export * from "./product-card-simple.vue?vue&type=script&lang=js"

import "./product-card-simple.vue?vue&type=style&index=0&id=08d1cf3e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__